import { useEffect, useRef, useState } from 'react'
import { Combobox } from '@headlessui/react'
import { usePathname } from 'next/navigation'
import { useTranslation } from 'react-i18next'

interface Region {
    id: number,
    name: string
}

type Props = {
    list: string[],
    setOption: (key, value) => void,
    isOpen: boolean,
    selectedOption: string,
    stateKey: string,
    setState: (key, value) => void,
    toggleState: (key) => void
}

export const ForPartnersAutocomplete: React.FC<Props> = ({ list, setOption, isOpen, selectedOption, stateKey, setState, toggleState }) => {
    const pathname = usePathname()
    const isCatalog = pathname.includes('/catalog')
    const [query, setQuery] = useState('')
    const selectRef = useRef<HTMLDivElement>(null)
    const { t } = useTranslation()

    useEffect(() => {
        if (selectedOption === '') {
            setQuery('')
        }
    }, [selectedOption])

    const handleInputChange = (event) => {
        setQuery(event.target.value)
        if (!isOpen) {
            setState(stateKey, true)
        }
    }

    const openOptions = () => {
        if (!isOpen) {
            toggleState(stateKey)
            setQuery('')
            setOption(stateKey, '')
        }
    }

    const toggleOptions = () => {
        toggleState(stateKey)
        if (!isOpen) {
            setQuery('')
            setOption(stateKey, '')
        }
    }

    const changeOption = (item) => {
        setOption(stateKey, item)
        setState(stateKey, false)
        setQuery(item)
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (selectRef.current && !event.composedPath().includes(selectRef.current) && selectRef.current.classList.contains('for-partners__select_open')) {
                setState(stateKey, false)
                setQuery(selectedOption)
            }
        }

        document.body.addEventListener('click', handleClickOutside)
        return () => document.body.removeEventListener('click', handleClickOutside)
    }, [selectedOption])

    const filteredPeople =
        query === ''
            ? list
            : list.filter((person) =>
                person
                    .toLowerCase()
                    .replace(/\s+/g, '')
                    .includes(query?.toLowerCase().replace(/\s+/g, ''))
            )

    return (
        <div className={`for-partners__input-block ${isOpen && 'for-partners__input-block_focused'}`}>
            <p className='for-partners__label-text'>{t('footerFormwhereUFrom')}</p>
            <div ref={selectRef} className={`for-partners__select ${isOpen && 'for-partners__select_open'}`}>
                <div
                    style={isOpen ? { color: '#7EC9FF' } : {}}
                    onClick={openOptions}
                    className='for-partners__select-btn'>
                    <input
                        value={query}
                        placeholder={t('footerFormwhereUFrom')}
                        type="text"
                        onChange={handleInputChange}
                    />
                    <svg onClick={toggleOptions} style={isOpen ? { transform: 'rotate(180deg)' } : {}} width="40" height="40" viewBox="0 0 40 40" fill="none">
                        <path d="M10 16L19.9366 24.1531C19.9734 24.1833 20.0266 24.1833 20.0634 24.1531L30 16" stroke="#A9B4D1" strokeWidth="3" strokeLinecap="round" />
                    </svg>
                </div>
                <div className="for-partners__select-list-wrapper">
                    <ul className={`for-partners__select-list ${isOpen && 'for-partners__select-list_open'} ${isCatalog && 'for-partners__select-list_catalog'}`}>
                        {filteredPeople.length ? filteredPeople?.map((item) => (
                            <li
                                onClick={() => changeOption(item)}
                                key={item}
                                className={selectedOption === item ? 'for-partners__select-option for-partners__select-option_selected' : 'for-partners__select-option'}
                                value={item}>
                                {item}
                            </li>
                        ))
                            :
                            <li
                                className='for-partners__select-option'
                            >
                                ничего не найдено
                            </li>
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default ForPartnersAutocomplete;
